<template>
  <div class="breadcrumb-container">
    <h2 class="current-page-title">{{ currentPageTitle }}</h2>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item 
        v-for="(item, index) in breadcrumbItems" 
        :key="item.path"
        :to="index < breadcrumbItems.length - 1 ? item.path : undefined"
      >
        <el-icon v-if="item.meta?.icon" class="breadcrumb-icon">
          <component :is="getIconComponent(item.meta.icon)" />
        </el-icon>
        <span>{{ item.meta?.title || '' }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { constantRoutes, generateBreadcrumbFromRoutes } from '../router'
import { House, UserFilled, Cpu, Key } from '@element-plus/icons-vue'

// 图标名称到组件的映射
const iconComponents = {
  House,
  UserFilled,
  Cpu,
  Key
}

export default {
  name: 'AppBreadcrumb',
  components: {
    ...iconComponents
  },
  props: {
    // 当前路径，默认为当前路由路径
    path: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      breadcrumbItems: []
    }
  },
  computed: {
    currentPageTitle() {
      if (this.breadcrumbItems.length > 0) {
        const lastItem = this.breadcrumbItems[this.breadcrumbItems.length - 1]
        return lastItem.meta?.title || ''
      }
      return ''
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler(newPath) {
        this.updateBreadcrumb(newPath)
      }
    },
    path(newPath) {
      if (newPath) {
        this.updateBreadcrumb(newPath)
      }
    }
  },
  mounted() {
    const path = this.path || this.$route.path
    this.updateBreadcrumb(path)
  },
  methods: {
    getIconComponent(iconName) {
      return iconComponents[iconName] || House
    },
    updateBreadcrumb(path) {
      // 获取布局路由的子路由
      const layoutRoute = constantRoutes.find(route => route.path === '/')
      if (layoutRoute && layoutRoute.children) {
        this.breadcrumbItems = generateBreadcrumbFromRoutes(layoutRoute.children, path)
      } else {
        this.breadcrumbItems = []
      }
    }
  }
}
</script>

<style scoped>
.breadcrumb-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.current-page-title {
  margin: 0;
  color: #333;
  font-size: 20px;
  font-weight: 600;
}

.breadcrumb-icon {
  margin-right: 4px;
  vertical-align: middle;
}

:deep(.el-breadcrumb__inner) {
  display: flex;
  align-items: center;
}
</style>
